export const CHAT_SOURCE_NOTIFICATION = 0;
export const CHAT_SOURCE_PROFILE = 1;
export const CHAT_SOURCE_DIRECT_LINK = 4;
